/* eslint-disable */
(function() {
  var $ = require('jquery');

  $(function() {
    var hash = window.location.hash.substring(1);

    //gets offset of the container (adds 15 for the padding) and sets it to the inner step as padding-left
    //once that is done it then makes the step full width which has a css transition and delay on it to give the effect of sliding out.
    function basketStep() {
      var containerPos = $('.container').offset().left + 15;

      $('.basket .inner-step').css('padding-left', containerPos);

      $('.basket .step1 .step').css('width', '100%');
    }

    basketStep();

    $(window).resize(function() {
      basketStep();
    });

    //on page load add active class to first step and slide down first step once page has finished animating!
    if (typeof hash !== 'undefined' && hash === 'step2') {
      $('.step2.basket-step').addClass('active-step');
      $('.basket .step1 .step').css('width', '0%');
      $('.basket .step2 .step').css('width', '100%');
      setTimeout(function() {
        $('.step2 .basket-step-main').slideDown();
      }, 1000);
    } else {
      $('.step1.basket-step').addClass('active-step');

      setTimeout(function() {
        $('.step1 .basket-step-main').slideDown();
      }, 1000);
    }

    //on click of proceed button slide up and down depending on which is clicked
    $('.proceed-checkout').click(function() {
      if (
        $(this)
          .closest('.basket-step')
          .hasClass('active-step')
      ) {
        $('.step1 .basket-step-main').slideUp(400, function() {
          $('.active-step').removeClass('active-step');
          $('.basket .step1 .step').css('width', '0%');
          $('.basket .step2 .step').css('width', '100%');
          setTimeout(function() {
            $('.step2 .basket-step-main').slideDown();
          }, 1000);
          $('.step2.basket-step').addClass('active-step');
        });
      } else {
        $('.active-step').removeClass('active-step');
        $('.basket .step2 .step').css('width', '0%');
        $('.step2 .basket-step-main').slideUp(400, function() {
          $('.basket .step1 .step').css('width', '100%');
          setTimeout(function() {
            $('.step1 .basket-step-main').slideDown();
          }, 1000);
          $('.step1.basket-step').addClass('active-step');
        });
      }
      return false;
    });
  });
})();
